import { ItemList } from 'orm'

class CompanyFileFieldMappingList extends ItemList {
    getEntityKey() {
        return "contact/company_file_field_mapping"
    }

}
export const companyFileFieldMappingList = new CompanyFileFieldMappingList("contact_file_field_mapping__default")
